import { useMutation, useQueryClient } from 'react-query'
import { useSvcCompareVersionsContext } from '@dc-shared-web/providers'
import { Note } from '@dc-shared-web/hooks/api/comparison/types'
import { createChangeNote } from '@dc-shared-web/hooks/api/comparison/createChangeNote'
import { COMPARISON_DATA_QUERY_KEY } from '@dc-shared-web/hooks/api/queryKeys'

interface CreateChangeNoteMutationParams {
  changeUuid: string
  content: string
  created_by: string
}

export const useCreateChangeNote = () => {
  const svcCompareVersionApiClient = useSvcCompareVersionsContext()
  const queryClient = useQueryClient()

  return useMutation<Note, Error, CreateChangeNoteMutationParams>({
    mutationFn: ({ changeUuid, content, created_by }) =>
      createChangeNote(svcCompareVersionApiClient, changeUuid, {
        content,
        created_by,
      }),
    onSuccess: () => {
      // Invalidate comparison data queries to refetch with updated notes
      queryClient.invalidateQueries([COMPARISON_DATA_QUERY_KEY])
    },
  })
}
